import { I as Input, d as defineCustomElement$1 } from './p-e3dd5b3e.js';
const OramaInput = Input;
const defineCustomElement = defineCustomElement$1;
export { OramaInput, defineCustomElement }; //# sourceMappingURL=orama-input.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JhbWEtaW5wdXQuanMiLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9